module.exports = __webpack_public_path__ + "img/20200724_local_start-up_experience_sharing.884f7d94.jpg";